/* unplugin-vue-components disabled */import { render } from "./Temple.vue?vue&type=template&id=104f4164&scoped=true"
import script from "./Temple.vue?vue&type=script&lang=js"
export * from "./Temple.vue?vue&type=script&lang=js"

import "./Temple.vue?vue&type=style&index=0&id=104f4164&scoped=true&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104f4164"]])

export default __exports__